import { Search, X } from 'lucide-react';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

/** Debouncing lives in `useTableQuery`, so this stays a controlled input. */
export function SearchInput({ value, onChange, placeholder = 'Search…' }: SearchInputProps) {
  return (
    <div className="relative min-w-56 flex-1 sm:max-w-xs">
      <label className="sr-only" htmlFor="table-search">
        Search
      </label>
      <Search
        className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-subtle"
        aria-hidden="true"
      />
      <input
        id="table-search"
        // `type="search"` in Safari renders a native clear affordance that
        // ignores React state; a text input with our own button stays in sync.
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className="w-full rounded-lg border border-line bg-card py-2 pl-9 pr-9 text-sm text-ink shadow-xs transition-[border-color,box-shadow] placeholder:text-subtle hover:border-line-strong focus:border-accent focus:outline-none focus:ring-2 focus:ring-[var(--sms-accent-ring)]"
      />
      {value !== '' && (
        <button
          type="button"
          onClick={() => onChange('')}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-subtle transition-colors hover:bg-surface-2 hover:text-ink"          aria-label="Clear search"
        >
          <X className="h-3.5 w-3.5" aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
